import { updatedDeviceList } from "./listAudioVideoInputs";

class CamHandler {
    constructor() {
        this._videoStream = null;
        this._facingMode = 'user';
        this._micList = [];
        this._camList = [];
        this._mainCam = '';
        // flags
        this._firstTime = true;
    }

    get facingMode() {
        return this._facingMode;
    }

    get camList() {
        return this._camList;
    }

    set camList(val) {
        throw "Operation not allowed";
    }

    get micList() {
        return this._micList;
    }

    set micList(val) {
        throw "Operation not allowed";
    }

    get videoStrem() {
        return this._videoStream;
    }

    set videoStrem(val) {
        throw "Operation not allowed";
    }

    // for devices with multiple camera, often the default option goes wrong
    findBackCam() {
        let isAndroid = false;
        //For android phones
        for (var i = 0; i < this._camList.length; i++) {
            if (this._camList[i].label.includes("0")) {
                this._mainCam = this._camList[i].label.deviceId;
                isAndroid = true;
                break;
            }
        }
        //For Iphones
        if (isAndroid === false) {
            for (var i = 0; i < this._camList.length; i++) {
                if (this._camList[i].label.includes("Back")) {
                    this._mainCam = this._camList[i].deviceId;
                    break;
                }
            }
        }
        // //console.log("[Cam Handler] main camera configured.")
    }


    clearTracks() {
        try {
            const tracks = this._videoStream.getTracks();
            tracks.forEach(track => track.stop());
        } catch { }
    }

    getStreamFromBrowser(options) {
        this.clearTracks();
        return new Promise((resolve, reject) => {
            try {
                navigator.mediaDevices.getUserMedia(options).then((stre) => {
                    this._videoStream = stre;
                    // //console.log("streamobj",stre)
                    if (this._firstTime) {
                        updatedDeviceList().then((liObj) => {
                            this._micList = liObj.audioLabels;
                            this._camList = liObj.videoLabels;
                            this.findBackCam();
                            // //console.log("test cam list",liObj.videoLabels)
                            document.dispatchEvent(new Event("mediaDeviceUpdated"));
                        })
                    }
                    resolve("success");
                    return;
                }).catch((e) => {
                    // //console.log("no camera",e.message,e.name)

                    reject(e);
                    return;
                });
            } catch {
                // //console.log("no front camera found!");
                reject("no " + options.video.facingMode);
            }
        });
    }

    getCam(videoOptions, facingMode) {
        return new Promise(async (resolve, reject) => {
            // if (this._videoStream){
            //     resolve("already collected");
            // }
            if (!videoOptions) {
                videoOptions = { facingMode: 'user' };
                facingMode = 'user';
            }
            // //console.log("video Options : ", videoOptions);
            const options = {
                audio: false,
                video: videoOptions
            }
            this._facingMode = facingMode;
            try {
                await this.getStreamFromBrowser(options);
                resolve({ status: true })
            } catch (e) {

                reject(e)
            }
        })
    }

    flipCam() {
        return new Promise(async (resolve, reject) => {
            const options = {};
            let facingMode = this._facingMode == 'user' ? 'environment' : 'user';
            if (facingMode == 'user') {
                options.facingMode = facingMode;
            } else {
                if (this._mainCam) options.deviceId = this._mainCam;
                else options.facingMode = facingMode;
            }
            try {
                await this.getCam(options, facingMode);
                resolve({ status: true });
            } catch (e) {
                reject({ status: false, err: e });
            }
        })
    }

}

export const camHandler = new CamHandler();